import $ from 'jquery';
import { nodeConfig } from '@/mixins';
import { Swap } from '@/plugins/swap';

const NAMESPACE = 'menu';
const DEFAULT_SELECTOR = '[data-js-menu]';
const DEFAULT_SETTINGS = {
	//
};

class Menu {
	constructor(node, config) {
		this.$node = $(node);
		this.config = config;

		this.$pageElements = $('body > *:not([data-js-menu])');
		this.$toggle = $('[data-js-menu-open]').first();
		this.$tabable = this.$node.find('a, button, input');
		this.$btnClose = this.$node.find('[data-js-menu-close]').first();
		this.$shiftingElements = $('[data-js-header], [data-js-page], [data-js-footer]');

		this.$document = $(document);
		this.$body = $('body');

		this.classLookup = {
			lock: 'fs-page-lock'
		};
	}

	onNodeTransitionEnd(event) {
		let propertyName = event?.originalEvent?.propertyName || false;

		if (propertyName !== 'opacity') return;

		this.$node.trigger('focus');
	}

	onKeydown(event) {
		let keyCode = event.key.toLowerCase();

		if (keyCode === 'escape') {
			this.$toggle.swap('deactivate');
		}
	}

	onSwapActivate() {
		this.$body.toggleClass(this.classLookup.lock, true);

		this.$tabable.removeAttr('tabindex');

		this.$pageElements.attr('inert', '');

		this.$shiftingElements.css({
			paddingRight: 'var(--scrollbar-width)'
		});

		this.$node.css({
			marginRight: '',
			width: ''
		});
	}

	onSwapDeactivate() {
		this.$body.toggleClass(this.classLookup.lock, false);

		this.$tabable.attr('tabindex', '-1');

		this.$pageElements.removeAttr('inert');

		this.$shiftingElements.css({
			paddingRight: ''
		});

		this.$node.css({
			marginRight: `calc(var(--scrollbar-width) * -1)`,
			width: `calc(100% + var(--scrollbar-width))`
		});
	}

	bindUI() {
		this.$node.on({
			keydown: this.onKeydown.bind(this),
			transitionend: this.onNodeTransitionEnd.bind(this)
		});

		Swap.on(this.$toggle[0], 'activate', this.onSwapActivate.bind(this));
		Swap.on(this.$toggle[0], 'deactivate', this.onSwapDeactivate.bind(this));
	}

	setup() {
		new Swap(this.$toggle[0], {
			target: '#menu',
			id: 'menu',
			triggerAttributes: [
				{
					attribute: 'aria-expanded',
					on: 'true',
					off: 'false'
				}
			],
			targetAttributes: [
				{
					attribute: 'aria-hidden',
					on: 'false',
					off: 'true'
				},
				{
					attribute: 'inert',
					on: false,
					off: 'inert'
				}
			],
			focusOnDeactivate: true,
		});

		new Swap(this.$btnClose[0], {
			principal: 'menu',
		});

		this.$node.attr({
			role: 'dialog',
			'aria-modal': 'true',
			'aria-hidden': 'true',
			tabindex: '-1'
		});

		this.$tabable.attr('tabindex', '-1');

		this.$toggle.attr({
			'aria-haspopup': 'true'
		});
	}

	init() {
		this.setup();
		this.bindUI();
	}
}

export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	let listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		let config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		let module = new Menu(node, config);

		module.init();

		return module;
	});
}
